import React, { useState, useEffect } from "react";

const DEFAULT_LOGO = '/defaults/default-logo.svg';
const DEFAULT_PARTNER = '/defaults/default-partner.svg';

const handleImgError = (e, fallback) => { e.target.onerror = null; e.target.src = fallback; };

function Footer() {
  const [logo, setLogo] = useState('');
  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) throw new Error("Failed to fetch promotions");
        const data = await response.json();
        setLogo(data[0].logo);
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };
    fetchPromotions();
  }, []);

  const origin = window.location.origin.replace(/^https?:\/\/(www\.)?/, '').replace(/(\.com|\.live|\.net)$/i, '');

  return (
    <footer className="et-l et-l--footer">
      <div className="et_builder_inner_content et_pb_gutters3">
        <div className="et_pb_section et_pb_section_0_tb_footer et_pb_with_background et_section_regular">
          <div className="et_pb_row et_pb_row_0_tb_footer">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_0_tb_footer et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_code et_pb_code_0_tb_footer">
                <div className="et_pb_code_inner">
                  <div className="mcw-rf clearfix">
                    <ul className="ul3">
                      <li className="li1"><a href="/"><img decoding="async" src={logo ? `${process.env.REACT_APP_API_URL}/storage/${logo}` : DEFAULT_LOGO} alt="Logo" onError={e => handleImgError(e, DEFAULT_LOGO)} /></a></li>
                      <li className="li2">
                        <p><small> Official Brand Partner </small></p>
                        <a href="https://newcity.vip/" target="_blank" rel="noopener noreferrer"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2024/11/NC_entrypage-banner.png" alt="Brand Partner" onError={e => handleImgError(e, DEFAULT_PARTNER)} /></a>
                      </li>
                      <li>
                        <p><a href="/" target="_blank" rel="noopener noreferrer">Payment Agent Partnership</a> | <a href="/">Terms &amp; Conditions</a></p>
                        <p>© {origin} 2025 Copyrights. All Rights Reserved</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="et_pb_section et_pb_section_1_tb_footer et_pb_with_background et_section_regular">
          <div className="et_pb_row et_pb_row_1_tb_footer">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_1_tb_footer et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_code et_pb_code_1_tb_footer">
                <div className="et_pb_code_inner">
                  <div className="mcw-rfm"><a href="/" target="_blank" rel="noopener noreferrer">Payment Agent Partnership</a> | <a href="/">Terms &amp; Condition</a></div>
                  <div className="mcw-rfm">
                    <ul>
                      <li><a href="/"><img decoding="async" src={logo ? `${process.env.REACT_APP_API_URL}/storage/${logo}` : DEFAULT_LOGO} alt="Logo" onError={e => handleImgError(e, DEFAULT_LOGO)} /></a></li>
                      <li className="li2">
                        <p><small> Trusted Brand Partner of New City VIP </small></p>
                        <a href="https://newcity.vip/" target="_blank" rel="noopener noreferrer"><img decoding="async" src="https://bd.mcwaffiliates.com/wp-content/uploads/2024/11/NC_entrypage-banner.png" alt="Brand Partner" onError={e => handleImgError(e, DEFAULT_PARTNER)} /></a>
                      </li>
                      <li>
                        <p>Best Quality Platform</p>
                        <p>© 2025 Copyrights. All Rights Reserved</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="et_pb_section et_pb_section_2_tb_footer et_pb_with_background et_section_regular et_pb_section--absolute">
          <div className="et_pb_row et_pb_row_2_tb_footer">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_2_tb_footer et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_code et_pb_code_2_tb_footer">
                <div className="et_pb_code_inner">
                  <div id="footerFloatBanner-41400" className="float-banner" style={{ display: 'none' }}>
                    <a href="#!" className="btn-close" id="closeFloatBanner" aria-label="Close"> </a>
                    <a href="#!" className="float-banner-promotion data-image" style={{ backgroundImage: 'url(/wp-content/uploads/2024/02/MCWAff_Float-Banner_ver3_EN.gif)', cursor: 'pointer' }} rel="noopener noreferrer" aria-label="Promotion"> </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
